import type { AppVariant } from './types';

// eslint-disable-next-line @typescript-eslint/no-extraneous-class -- this is a singleton class
export default class MatrixEndpoint {
  static getClient() {
    return '' as string | undefined;
  }

  static getAppVariant() {
    return 'development' as AppVariant | undefined;
  }

  static getMatrixEndpoint() {
    return '' as string | undefined;
  }

  static getMatrixEndpointIcon() {
    return '' as string | undefined;
  }

  static getActiveAppVariant() {
    return '';
  }

  static getDefaultLocale() {
    return '';
  }

  /**
   * This function is used to determine if the app is running in the preview app
   * or on a device. This is used to determine if the shake event should be enabled
   * for the debug menu.
   */
  static getIsMatrixPreviewApp() {
    return false;
  }

  /**
   * Determines whether to use the published version of the application interface.
   * The decision is based on the matrix endpoint and app variant.
   *
   * Cases when published version is used:
   * 1. When matrix endpoint is configured and app variant is not 'development'
   * 2. When running client-specific build (with matrix endpoint configured)
   *
   * Cases when saved version is used:
   * 1. When using UnifyAppsPreview app (no matrix endpoint)
   * 2. When running development build (app variant is 'development')
   *
   */
  static getShouldUsePublishedVersion() {
    return false;
  }

  static getSplashScreenBackgroundColor() {
    return '';
  }

  static getUserInterfaceStyle() {
    return undefined as 'light' | 'dark' | 'automatic' | undefined;
  }

  static getExtraFonts() {
    return undefined as Record<string, string> | undefined;
  }
}
